export { Prophet as reactClass } from './src/index'
export { default as settingsClass } from './src/views/settings-class'
export { reducer } from './src/redux'
export { initHandler as pluginDidLoad, destroyHandler as pluginWillUnload } from './src/game-handler'

export const switchPluginPath = [
  '/kcsapi/api_req_map/start',
  '/kcsapi/api_req_practice/battle',
  '/kcsapi/api_req_map/next',
  '/kcsapi/api_req_map/air_raid',
]
